export function isLoyaltyPointsEnabled(): boolean {
  return import.meta.env.VITE_ENABLE_LOYALTY_POINTS === "true"
}
